/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  const PROCESSED_ATTRIBUTE_NAME = 'data-appstle-wrapped';

  function wrapAppstle(el) {
    if (el.hasAttribute(PROCESSED_ATTRIBUTE_NAME)) return;
    const [first, ...rest] = el.textContent.split(';');
    el.innerHTML = rest.length ? `<span>${first}</span>${rest.join(';')}` : `<span>${first}</span>`;
    el.setAttribute(PROCESSED_ATTRIBUTE_NAME, '');
  }

  function observeForAppstle() {
    const el = document.querySelector('.appstle_subscription_description_text');
    if (el) {
      wrapAppstle(el);
      return;
    }
    if (!document.body) return;
    const observer = new MutationObserver(() => {
      const target = document.querySelector('.appstle_subscription_description_text');
      if (target) {
        wrapAppstle(target);
        observer.disconnect();
        clearTimeout(timeoutId);
      }
    });
    const timeoutId = setTimeout(() => observer.disconnect(), 15000);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeForAppstle);
  } else {
    observeForAppstle();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})(); 
